"use strict";

const $ = require("jquery");
const css = require("js/css_constants");

const css_alert = "alert";
const css_success = "alert-success";
const css_info = "alert-info";
const css_danger = "alert-danger";

const CLOSE_ON_EVENT = "close_on_event";
const SUCCESS = "SUCCESS";
const DANGER = "DANGER";
const INFO = "INFO";
const CANCEABLE_OPERATION = "CANCEABLE_OPERATION";
const OPERATION_FINISHED = "OPERATION_FINISHED";

module.exports.init = function (alertContainer) {
    function show(msg, cssClass, cancelId, timeout = 10000) {
        if (msg == "") {
            console.warn("Suppressing empty message !");
            return;
        }
        // create a container to show messages
        const msgContainer = document.createElement("div");

        if (cancelId != null) {
            const spinner = document.createElement("div");
            spinner.classList.add("loader");
            spinner.classList.add("small");
            spinner.classList.add("mr-4");
            msgContainer.append(spinner);
        }

        const lineContainer = document.createElement("p");
        msgContainer.append(lineContainer);

        const lines = msg.split("\n");
        for (let i = 0; i < lines.length; i++) {
            lineContainer.append(lines[i]);

            if (i < lines.length - 1) {
                lineContainer.append(document.createElement("br"));
            }
        }
        msgContainer.classList.add(cssClass);
        msgContainer.classList.add("alert");
        msgContainer.classList.add("flex");
        msgContainer.classList.add("flex-row");

        // add message to the alert messages
        alertContainer.appendChild(msgContainer);
        alertContainer.classList.remove(css.disabled);

        msgContainer.addEventListener("click", (e) => {
            hide(msgContainer)();
        });

        if (cancelId != null) {
            msgContainer.dataset.cancelId = cancelId;
        } else if (timeout == "close_on_event") {
            msgContainer.dataset.closeOnEvent = "true";
        } else {
            alertContainer.classList.remove(css.disabled);
            setTimeout(hide(msgContainer), timeout);
        }

        return msgContainer;
    }

    function hide(msgContainer) {
        return () => {
            alertContainer.removeChild(msgContainer);

            if (alertContainer.childElementCount == 0) {
                alertContainer.classList.add(css.disabled);
            }
        };
    }

    function showApiResponse(resp) {
        if (resp.result == "success") {
            success(resp.msg);
        } else if (resp.result == "info") {
            info(resp.msg);
        } else {
            danger(resp.msg);
        }
    }

    function success(msg, timeout = 10000) {
        show(msg, css_success, null, timeout);
    }

    function info(msg, timeout = 10000) {
        show(msg, css_info, null, timeout);
    }

    function danger(msg, timeout = 10000) {
        show(msg, css_danger, null, timeout);
    }

    function canceableOperation(msg, cancelId) {
        show(msg, css_info, cancelId);
    }

    function closeBySelector(selector) {
        alertContainer.querySelectorAll(selector).forEach((msgContainer) => alertContainer.removeChild(msgContainer));
    }

    document.addEventListener("ldc-alert", (e) => {
        switch (e.detail.severity) {
            case CLOSE_ON_EVENT:
                closeBySelector("*[data-close-on-event=true]");
                break;
            case INFO:
                info(e.detail.msg, e.detail.timeout);
                break;
            case CANCEABLE_OPERATION:
                canceableOperation(e.detail.msg, e.detail.cancelId);
                break;
            case OPERATION_FINISHED:
                closeBySelector(`*[data-cancel-id='${e.detail.cancelId}']`);
                break;
            case SUCCESS:
                success(e.detail.msg, e.detail.timeout);
                break;
            case DANGER:
            default:
                danger(e.detail.msg, e.detail.timeout);
                break;
        }
    });
};

module.exports.danger = function (dispatcher, msg, timeout = 10000) {
    __fireEvent(dispatcher, DANGER, msg, timeout);
};

module.exports.info = function (dispatcher, msg, timeout = 10000) {
    __fireEvent(dispatcher, INFO, msg, timeout);
};

module.exports.canceableOperation = function (dispatcher, msg, cancelId) {
    __fireEvent(dispatcher, CANCEABLE_OPERATION, msg, -1, cancelId);
};

module.exports.operationFinished = function (dispatcher, cancelId) {
    __fireEvent(dispatcher, OPERATION_FINISHED, "", -1, cancelId);
};

module.exports.success = function (dispatcher, msg, timeout = 10000) {
    __fireEvent(dispatcher, SUCCESS, msg, timeout);
};

module.exports.CLOSE_ON_EVENT = CLOSE_ON_EVENT;

module.exports.closeAllOnEventMsgs = function (dispatcher) {
    __fireEvent(dispatcher, CLOSE_ON_EVENT, "no msg", 0);
};

module.exports.httpFailure = function (jqueryErr) {
    const msg =
        "Error while talking to server!\n\nhttp status code: " +
        jqueryErr.status.toString() +
        "\nhttp status text: " +
        jqueryErr.statusText;
    __fireEvent(document.body, DANGER, msg);
};

module.exports.showApiResponse = function showApiResponse(dispatcher, resp) {
    if (resp.msg != null) {
        if (resp.msg.level == "success") {
            __fireEvent(dispatcher, SUCCESS, resp.msg.content);
        } else if (resp.msg.level == "info") {
            __fireEvent(dispatcher, INFO, resp.msg.content);
        } else {
            __fireEvent(dispatcher, DANGER, resp.msg.content);
        }
    }
};

function __fireEvent(dispatcher, severity, msg, timeout, cancelId = null) {
    let event = new CustomEvent("ldc-alert", {
        bubbles: true,
        composed: true,
        detail: {
            msg: msg,
            dispatcher: dispatcher,
            severity: severity,
            timeout: timeout,
            cancelId: cancelId,
        },
    });
    dispatcher.dispatchEvent(event);
}
